<template>
  <div class="font-sans-serif">
    <div class="flex flex-col p-10">
      <span class="uppercase text-xl pb-6">{{ $t('upload.chooseType') }}</span>
      <div class="flex w-full items-center justify-between flex-wrap text-sm lg:text-lg">
        <div class="flex items-center">
          <input type="radio" id="image" value="image" v-model="type">
          <label for="image" class="pl-2">{{ $t('upload.image') }}</label>
        </div>
        <div class="flex items-center">
          <input type="radio" id="pdf" value="pdf" v-model="type">
          <label for="pdf" class="pl-2">{{ $t('upload.pdf') }}</label>
        </div>
        <div class="flex items-center">
          <input type="radio" id="video" value="video" v-model="type">
          <label for="video" class="pl-2">{{ $t('upload.video') }}</label>
        </div>
        <div class="flex items-center">
          <input type="radio" id="audio" value="audio" v-model="type">
          <label for="audio" class="pl-2">{{ $t('upload.audio') }}</label>
        </div>
      </div>
    </div>
    <div class="bg-beige-academy-300 border-2 border-dashed border-white font-light px-20 py-10
    rounded text-center text-white text-sm lg:text-xl w-full relative"
      @dragenter.prevent="onDragEnter"
      @dragleave.prevent="onDragLeave"
      @dragover.prevent
      @drop.prevent.stop="onDrop"
      :class="{dragging: isDragging}"
      v-if="type">

      <div class="absolute w-full bg-white top-0 left-0 rounded-t-lg p-3 md:p-6 pb-4 text-right"
        v-show="file">
        <div class="upload-control">
            <label for="file">{{ $t('upload.select') }}</label>
            <button @click.prevent="upload" :class="{loader: loading}">
              {{ $t('upload.upload') }}
            </button>
        </div>
      </div>

      <div class="uploader" v-if="!file">
        <p>{{ $t('upload.drag') }}{{type}})</p>
        <div>{{ $t('upload.or') }}</div>
        <div class="w-2/3 mx-auto flex flex-col relative">
          <label for="file">{{ $t('upload.select') }}</label>
          <input
            type="file"
            id="file"
            multiple
            @change="onInputChange">
      </div>
    </div>
      <div class="flex flex-wrap mt-20"
        v-else>
          <div class="flex flex-col bg-white text-blue-400 w-full justify-between shadow-lg m-4">
              <div class="flex flex-col text-black text-xs text-left px-4 py-4">
                <span v-text="file.name"></span>
                <span v-text="getFileSize(file.size)"></span>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';

export default {
  data: () => ({
    isDragging: false,
    dragCount: 0,
    file: null,
    loading: false,
    sharedState: {
      uploaded: false,
    },
    type: '',
  }),

  props: ['id'],

  methods: {
    ...mapActions({
      updatedSlots: 'slots/updatedSlots',
    }),

    onDragEnter() {
      this.dragCount += 1;
      this.isDragging = true;
    },
    onDragLeave() {
      this.dragCount -= 1;

      if (this.dragCount <= 0) { this.isDragging = false; }
    },
    onDrop(e) {
      this.isDragging = false;

      const { files } = e.dataTransfer;

      Array.from(files).forEach((file) => this.addFile(file));
    },
    onInputChange(e) {
      const { files } = e.target;

      Array.from(files).forEach((file) => this.addFile(file));
    },
    addFile(file) {
      if (!file.type.match(this.type)) {
        this.createNotification('error', `${file.name} ${this.$t('upload.notFormat')}`);
        return;
      }

      this.file = file;

      const reader = new FileReader();

      reader.readAsDataURL(file);
    },
    getFileSize(givenSize) {
      let size = givenSize;
      const fSExt = ['Bytes', 'KB', 'MB', 'GB'];
      let i = 0;

      while (size > 900) {
        size /= 1024;
        i += 1;
      }
      return `${(Math.round(size * 100) / 100)} ${fSExt[i]}`;
    },
    upload() {
      this.loading = true;
      const formData = new FormData();

      formData.set('file', this.file);
      formData.set('description', this.file.name);
      formData.set('type', 'image');

      axios.post(`/api/teachers/${this.id}/media`, formData)
        .then(() => {
          this.$emit('media-uploaded');
          this.$modal.hide('media-uploader');
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.createNotification('error', this.$t('notifications.errorTryAgain'));
        });
    },
  },
};
</script>

<style lang="scss" scoped>
    .uploader {
      label,
      input {
          @apply bg-white text-background-academy w-full top-0 left-0 p-4;
          @apply rounded mt-4 cursor-pointer;
      }

        input {
            opacity: 0;
            z-index: -2;
        }

        label {
            @apply absolute;
        }
    }

    .dragging {
        @apply bg-white text-blue-400 border-blue-400;

        div > label {
            @apply bg-blue-400 text-white;
        }
    }

    .upload-control {
        label,
        button {
            @apply text-background-academy bg-beige-academy-100 px-6 py-4 rounded cursor-pointer;
        }

        label {
            @apply py-5 mr-4;
        }
    }

</style>
